<template>
  <v-app id="inspire">
    <v-main :style="{
      backgroundImage: 'url(../../backgim.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    }">
      <v-app-bar :height="height">
        <v-icon size="30" color="blue darken-3">mdi-triangle</v-icon>
        <v-app-bar-title class="pr-4
            text-sm-h6         
            text-md-h6          
            text-lg-h4      
            text-xl-h4">
          Triyangle.
        </v-app-bar-title>
        <v-row>
          <v-col cols="12" sm="6" md="6" lg="6" xl="9">
            <v-text-field hide-details full-width append-icon="mdi-email" v-model="signIn.email"
              :rules="[rules.signIn.email]" autocomplete="email" clearable filled focusable placeholder="Email"
              required></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="6" xl="9">
            <v-text-field v-model="signIn.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.signIn.password]" :type="show1 ? 'text' : 'password'" hide-details="auto"
              @click:append="show1 = !show1" placeholder="Password" required filled clearable></v-text-field>
          </v-col>
        </v-row>
        <v-col class="pr-4 pt-4
                text-sm-h6         
                text-md-h6          
                text-lg-h4      
                text-xl-h4">
          <v-btn color="primary" elevation="10" small @click="handleLogin">
            SIGN IN
          </v-btn>
        </v-col>
      </v-app-bar>
      <v-col class="float-right pt-6" cols="12" sm="9" md="9" lg="6" xl="12">
        <v-sheet rounded="lg" color="grey lighten-2">
          <!--  -->
          <v-toolbar color="blue darken-4" cards dark flat>
            <v-icon size="30">mdi-triangle</v-icon>
            <v-card-title class="text-md-h5
                    text-sm-h6 
                    text-lg-h5         
                    text-xl-h4         
                    text-truncate">
              Sign up to Triyangle.
            </v-card-title>
          </v-toolbar>
          <v-form ref="form" v-model="form" class="pl-4 pr-4">
            <v-row>
              <v-col cols="12" sm="12" md="6" lg="6" xl="3">
                <v-text-field hide-details="auto" label="First name" :rules="[rules.name]" filled required
                  v-model="firstName"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="3">
                <v-text-field hide-details label="Last name" filled required v-model="lastName"></v-text-field>
              </v-col>
            </v-row>
            <v-text-field hide-details v-model="email" :rules="[rules.email]" filled color="deep-purple"
              label="Email address" type="email"></v-text-field>
            <v-text-field hide-details v-model="profession" filled color="deep-purple" label="Interest / Field of Study"
              type="text"></v-text-field>
            <v-tooltip left width="1px">
              <template v-slot:activator="{ on }">
                <v-select v-model="countriesOfAssociation" chips v-on="on" clearable multiple hide-details
                  :items="options" prepend-inner-icon="mdi-map-marker" filled color="deep-purple" required
                  placeholder="Countries of association(eg: Angola, United States)">
                  <v-autocomplete v-model="countriesOfAssociation" :items="options" item-text="name" solo multiple
                    clearable>
                  </v-autocomplete>
                </v-select>
              </template>
              <span>Choose one country on the continent and where you are in the diaspora (if any, Maximum 2)</span>
            </v-tooltip>
            <v-text-field v-model="password" :rules="[rules.password, rules.length(8)]"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show2 ? 'text' : 'password'" hide-details="auto"
              @click:append="show2 = !show2" filled color="deep-purple" counter="8" label="Password" required
              clearable></v-text-field>
            <v-text-field v-model="confirmPassword" :rules="[passwordConfirmationRule(), rules.length(8)]"
              :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'" :type="show3 ? 'text' : 'password'" hide-details="auto"
              @click:append="show3 = !show3" filled color="deep-purple" counter="8" label="Retype Password" required
              clearable></v-text-field>
            <v-checkbox v-model="agreement" :rules="[rules.required]" color="deep-purple">
              <template v-slot:label>
                I agree to the&nbsp;
                <a href="#" @click.stop.prevent="dialog = true">Terms of Service</a>
                &nbsp;and&nbsp;
                <a href="#" @click.stop.prevent="dialog = true">Privacy Policy</a>*
              </template>
            </v-checkbox>
          </v-form>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn text @click="$refs.form.reset()">
              Clear
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="!form" :loading="isLoading" class="white--text" color="deep-purple accent-4" depressed
              @click="signUp">
              Submit
            </v-btn>
          </v-card-actions>
          <v-dialog v-model="dialog" absolute max-width="400" persistent>
            <v-card>
              <v-card-title class="text-h5 grey lighten-3">
                Legal
              </v-card-title>
              <v-card-text>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore
                magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                commodo
                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                pariatur.
                Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est
                laborum.
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn text @click="agreement = false, dialog = false">
                  No
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="white--text" color="deep-purple accent-4" @click="agreement = true, dialog = false">
                  Yes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-sheet>
      </v-col>
    </v-main>
  </v-app>
</template>

<script>
import countries from './plainCountries.json'
export default {
  name: 'signUp',
  data: () => ({
    // Variables
    //
    myCountries: countries,
    password1: 'Password',
    show1: false,
    show2: false,
    show3: false,
    signIn: {
      email: '',
      password: '',
    },
    agreement: false,
    dialog: false,
    email: undefined,
    form: false,
    isLoading: false,
    password: undefined,
    confirmPassword: undefined,
    countriesOfAssociation: '',
    country: undefined,
    profession: '',
    firstName: '',
    lastName: '',
    rules: {
      name: v => !!(v || '') || 'Please enter a valid name',
      email: v => !!(v || '').match(/@/) || 'Please enter a valid email',
      length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
      password: v => !!(v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
        'Password must contain an upper case letter, a numeric character, and a special character',
      confirmPasswordRules: v => !!v || "Password is required",
      required: v => !!v || 'This field is required',
      signIn: {
        email: v => !!(v || '') || 'Please enter a valid email',
        password: v => !!(v || '')
      }
    },
  }),
  props: {
  },
  computed: {
    // Change height with different screen size
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 190;
        case 'sm': return 69;
        case 'md': return 69;
        case 'lg': return 69;
        case 'xl': return 69;
        default: return 190;
      }
    },
    // Country options 
    //
    options() {
      return countries.map(country => ({
        text: country.name,
        value: country.id
      }))
    },
    // Password must match
    //
    passwordConfirmationRule() {
      return () =>
        this.password === this.confirmPassword || "Password must match";
    }
  },
  methods: {
    // Sign up method
    //
    signUp() {
      let user = {
        email: this.email,
        first_name: this.firstName,
        last_name: this.lastName,
        password: this.password,
        profession: this.profession,
        country: this.countriesOfAssociation[0] + ' - ' + this.countriesOfAssociation[1]
      }
      this.$store.dispatch('auth/register', user).then(res => {
        console.log(res)
        this.$success('Signup successfully. Please login to continue!')
        setTimeout(() => {
          window.location.reload()
        }, 3000)
      }).catch(error => {
        this.$error(error)
      })
    },
    // Login method
    //
    handleLogin() {
      if (this.signIn.email && this.signIn.password) {
        this.$store.dispatch('auth/login', this.signIn).then(
          () => {
            this.$success("Login successfully!")
            this.$router.push('/globe');
          },
          error => {
            console.log(error)
            this.$error("Invalid email or password")
          }
        );
      }
    },
  }
}
</script>
